'use client'

import { useState, useEffect, useRef } from 'react'
import { usePathname, useRouter } from '@/navigation'
import { useSelector, useDispatch } from '@/hooks/redux'
import {
  setPath,
  setFlowType,
  setEntryModule,
  nextPage
} from '@/reducers/workflow'
import { findModule } from '@/workflows/utils'
import { Spin } from 'antd'

export default function WorkflowNavigation({
  children
}: {
  children: React.ReactNode
}) {
  const [loading, setLoading] = useState<boolean>(true)
  const pathname = usePathname()
  const router = useRouter()

  const dispatch = useDispatch()
  const {
    path: storedPath,
    flow,
    paid
  } = useSelector((state) => state.workflow)
  // path initialized avoid ping pong effect when redirecting on path != current
  const pathInitialized = useRef(false)

  useEffect(() => {
    // init flow
    const flowParam = sessionStorage.getItem('flowType')
    if (flowParam === 'create') {
      dispatch(setFlowType('create'))
      dispatch(setEntryModule())
      dispatch(nextPage('create'))
      pathInitialized.current = true
      sessionStorage.removeItem('flowType')
      return
    } else if (flowParam === 'transfert') {
      dispatch(setFlowType('transfert'))
      dispatch(setEntryModule())
      dispatch(nextPage('transfert'))
      pathInitialized.current = true
      sessionStorage.removeItem('flowType')
      return
    }

    // Path manipulation
    if (pathname === '/' && storedPath === undefined) {
      pathInitialized.current = true
      dispatch(setPath('/project'))
    } else if (pathname === '/') {
      pathInitialized.current = true
      dispatch(setPath(storedPath))
    } else if (pathname !== storedPath && flow.includes(pathname) && !paid) {
      dispatch(setPath(pathname))
    } else if (pathname !== storedPath && findModule(pathname)?.redirectPage) {
      dispatch(setPath(pathname))
    } else {
      pathInitialized.current = true
    }
  }, [])

  useEffect(() => {
    if (pathname !== storedPath && pathInitialized.current) {
      const currentIndex = flow.indexOf(pathname)
      const targetIndex = flow.indexOf(storedPath)
      const goingBack =
        targetIndex !== -1 &&
        (targetIndex < currentIndex || findModule(pathname)?.redirectPage)

      if (goingBack) {
        router.replace(storedPath)
      } else {
        router.push(storedPath)
      }
    }

    if (pathInitialized.current && pathname === storedPath) setLoading(false)

    if (!pathInitialized.current) pathInitialized.current = true
  }, [storedPath])

  return loading ? (
    <div className='absolute top-[50%] left-[50%]'>
      <Spin size='large' />
    </div>
  ) : (
    children
  )
}
